import React from 'react';
import { graphql, Link, StaticQuery } from 'gatsby';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import marked from 'marked';

import CDNImage from '../common/cdn-image';
import { ShoppingBagSvg } from '../common/svg';

import '../../styles/collections/collection-gallery.scss';


class CollectionGallery extends React.Component {
  constructor(props) {
    super(props);

    let galleryImages = props.galleryData.filter(el => el);
    galleryImages = galleryImages.map(el => {
      return `${el.src}?fit=max&w=2400`;
    });

    this.state = {
      galleryImages: galleryImages,
      lightboxOpen: false,
      lightboxIndex: 0,
    };
  }

  render() {
    const { galleryImages, lightboxOpen, lightboxIndex } = this.state;

    return (
      <StaticQuery
        query={graphql`
        {
          site {
            siteMetadata {
              imageHost
            }
          }
        }
        `}
        render={data => {
            const imageHost = data.site.siteMetadata.imageHost;

            return (
            <>
              <div className="collection__gallery">
                {this.props.galleryData.map((el, idx) => (
                  <div
                    className="collection__gallery__cell"
                    key={`gallery-image-${idx}`}
                  >
                    <button
                      className="collection__gallery__image"
                      onClick={() => {
                        this.setState({
                          lightboxOpen: true,
                          lightboxIndex: idx,
                        })
                      }}
                    >
                      <div className="collection__gallery__image-wrapper">
                        <CDNImage
                          imagePath={el.src}
                          alt={el.alt}
                          width={600}
                          showUndownloadedMessage={ true }
                        />
                      </div>
                    </button>
                    {(el.print && el.print.length > 0) ? (
                      <Link
                        to={`/product/${el.print}?utm_source=pdr&utm_medium=inpost&utm_campaign=prints&utm_content=pic`}
                        className="image__buy-a-print"
                      >
                        { ShoppingBagSvg }
                        {' '}
                        Buy as a Print
                      </Link>
                    ) : null}
                    {(el.caption) ? (
                      <div
                        className="collection__gallery__caption"
                        dangerouslySetInnerHTML={{ __html: marked(el.caption) }}
                      />
                    ) : null}
                  </div>
                ))}
              </div>
              {(lightboxOpen) ? (
                <Lightbox
                  mainSrc={imageHost + galleryImages[lightboxIndex]}
                  nextSrc={imageHost + galleryImages[(lightboxIndex + 1) % galleryImages.length]}
                  prevSrc={imageHost + galleryImages[(lightboxIndex + galleryImages.length - 1) % galleryImages.length]}
                  imagePadding={ 60 }
                  reactModalStyle={ { overlay: { zIndex: 99999 } }}
                  onCloseRequest={() => this.setState({ lightboxOpen: false })}
                  onMovePrevRequest={() =>
                    this.setState({
                      lightboxIndex: (lightboxIndex + galleryImages.length - 1) % galleryImages.length,
                    })
                  }
                  onMoveNextRequest={() =>
                    this.setState({
                      lightboxIndex: (lightboxIndex + 1) % galleryImages.length,
                    })
                  }
                />
              ) : null}
            </>
          );
        }}
      />
    );
  }
}

export default CollectionGallery;
